// @ts-nocheck
/**
 * Lasirius Desktop Smart-Sticky Product Details Experience
 * Handles Durum A (fits viewport), Durum B (taller than viewport), and Durum C (gallery boundary).
 * Ensures single natural page scroll with zero inner scrollbars.
 */
(() => {
  if (typeof window === 'undefined') return;

  function initSmartSticky() {
    const details = document.querySelector('.product-details.sticky-content--desktop');
    if (!details || details.dataset.smartStickyInit === 'true') return;

    const grid = document.querySelector('.product-information__grid');
    if (!grid) return;

    details.dataset.smartStickyInit = 'true';

    // The scroll container in this theme is .page-wrapper on desktop (>=990px), or window/document
    const getScrollContainer = () => {
      const pw = document.querySelector('.page-wrapper');
      if (pw && window.innerWidth >= 990) return pw;
      return window;
    };

    const getScrollTop = (cnt) => {
      if (cnt === window) return window.scrollY || document.documentElement.scrollTop || 0;
      return cnt.scrollTop || 0;
    };

    let container = getScrollContainer();
    let lastScrollTop = getScrollTop(container);
    let currentStickyTop = null;
    let ticking = false;

    const updateSticky = () => {
      ticking = false;

      // Only active on desktop (>=750px)
      if (window.innerWidth < 750) {
        details.style.removeProperty('--smart-sticky-top');
        details.style.removeProperty('top');
        return;
      }

      container = getScrollContainer();
      const scrollTop = getScrollTop(container);
      const delta = scrollTop - lastScrollTop;
      lastScrollTop = scrollTop;

      const vh = window.innerHeight;
      const header = document.querySelector('#header-component');
      const isHeaderSticky = header && (
        header.getAttribute('data-sticky-state') === 'active' ||
        header.classList.contains('header--sticky') ||
        header.classList.contains('sticky')
      );

      let headerH = 0;
      if (header) {
        const headerRect = header.getBoundingClientRect();
        if (headerRect.top <= 0 && headerRect.bottom > 0) {
          headerH = headerRect.bottom;
        } else if (isHeaderSticky) {
          headerH = header.offsetHeight;
        }
      }

      const topGap = 16;
      const bottomGap = 24;
      const maxTop = headerH + topGap;
      const detailsH = details.offsetHeight;
      const available = vh - maxTop - bottomGap;

      if (detailsH <= available) {
        // DURUM A: Details fit comfortably in viewport -> stick to top
        currentStickyTop = maxTop;
      } else {
        // DURUM B: Details are taller than viewport -> smart bidirectional docking
        const minTop = vh - detailsH - bottomGap;

        if (currentStickyTop === null) {
          // Initial placement: start at top
          currentStickyTop = maxTop;
        }

        if (delta > 0) {
          // Scrolling DOWN: allow details to move up until bottom docks at (vh - bottomGap)
          currentStickyTop = Math.max(minTop, currentStickyTop - delta);
        } else if (delta < 0) {
          // Scrolling UP: allow details to move down until top docks at maxTop
          currentStickyTop = Math.min(maxTop, currentStickyTop - delta);
        }
      }

      details.style.setProperty('--smart-sticky-top', `${Math.round(currentStickyTop)}px`);
      details.style.top = `var(--smart-sticky-top, ${maxTop}px)`;
    };

    const onScroll = () => {
      if (!ticking) {
        requestAnimationFrame(updateSticky);
        ticking = true;
      }
    };

    const attachListeners = () => {
      window.removeEventListener('scroll', onScroll);
      const pw = document.querySelector('.page-wrapper');
      if (pw) pw.removeEventListener('scroll', onScroll);

      container = getScrollContainer();
      if (container === window) {
        window.addEventListener('scroll', onScroll, { passive: true });
      } else {
        container.addEventListener('scroll', onScroll, { passive: true });
      }
    };

    attachListeners();
    window.addEventListener('resize', () => {
      attachListeners();
      updateSticky();
    }, { passive: true });

    // Recalculate immediately when details dimensions change (e.g. accordion open/close, variant change)
    if (typeof ResizeObserver !== 'undefined') {
      const resizeObserver = new ResizeObserver(() => {
        updateSticky();
      });
      resizeObserver.observe(details);
    }

    // Initial calculation
    updateSticky();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSmartSticky);
  } else {
    initSmartSticky();
  }

  document.addEventListener('shopify:section:load', initSmartSticky);
})();
